import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import ContactModal from 'Pods/Shared/ContactModal'

class RequestToBuyButton extends React.Component {
  constructor() {
    super()

    this.state = { contactModalIsOpen: false }

    this.toggleModal = this.toggleModal.bind(this)
    this.onButtonClick = this.onButtonClick.bind(this)
  }

  toggleModal() {
    this.setState({ contactModalIsOpen: !this.state.contactModalIsOpen })
  }

  onButtonClick() {
    if (this.props.userSignedIn) {
      this.toggleModal()
    } else {
      App.events.publish('app:login:open')
    }
  }

  render() {
    return (
      <div className="gallery__request">
        <button className="button--full btn btn-primary" onClick={this.onButtonClick}>
          <Icon type={['far', 'cart-plus']} size="lg" />
          Request to Buy it as 3D model
        </button>
        {this.state.contactModalIsOpen && (
          <ContactModal
            modalIsOpen
            closeModal={this.toggleModal}
            authorUsername={this.props.authorUsername}
            conversationType="personal"
            headerText={I18n.t('modals.request_to_buy_gallery.title')}
            subtitle={I18n.t('modals.request_to_buy_gallery.subtitle')}
            galleryId={this.props.galleryId}
            galleryTitle={this.props.galleryTitle}
            messagingForbidden={this.props.messagingForbidden}
          />
        )}
      </div>
    )
  }
}

RequestToBuyButton.propTypes = {
  userSignedIn: PropTypes.bool.isRequired,
  authorUsername: PropTypes.string.isRequired,
  galleryId: PropTypes.number.isRequired,
  galleryTitle: PropTypes.string.isRequired,
  messagingForbidden: PropTypes.bool.isRequired,
}

export default RequestToBuyButton
